import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { apiService } from '../services/api';

interface DeviceSettings {
  allow_revoke_device: boolean;
  allow_create_cli_token: boolean;
}

export const useCompanyDeviceSettings = () => {
  const { user } = useAuth();
  const [settings, setSettings] = useState<DeviceSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadSettings = async () => {
      if (!user?.company_id) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const deviceSettings = await apiService.getCompanyDeviceSettings(user.company_id);
        
        // Normalize the response to ensure both fields are always present
        const normalizedSettings: DeviceSettings = {
          allow_revoke_device: deviceSettings.allow_revoke_device !== undefined
            ? deviceSettings.allow_revoke_device
            : true,
          allow_create_cli_token: deviceSettings.allow_create_cli_token !== undefined
            ? deviceSettings.allow_create_cli_token
            : true,
        };
        
        setSettings(normalizedSettings);
      } catch (err: any) {
        console.error('Failed to load company device settings:', err);
        setError('Failed to load company device settings');
        // Default to both enabled if we can't load settings
        setSettings({
          allow_revoke_device: true,
          allow_create_cli_token: true,
        });
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, [user?.company_id]);

  return {
    settings,
    loading,
    error,
  };
};

